import { StyleSheet } from 'react-native';
import colors from '@/config/colors';

export const styles = StyleSheet.create({
  innerStyle: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
  },
  container: { flex: 1 },
  textStyle: {
    color: colors.darkPurpleBlue,
  },
  padding7: {
    padding: 7,
  },
  responsiveContainer: {
    flexDirection: 'column',
    alignItems: 'center',
  },
});
